export default {
  nav: {
    recommended: "Recomendados",
    hours: "Horario",
    directions: "Cómo llegar",
  },
  header: {
    whatsapp: "WhatsApp",
    switchAria: "Cambiar idioma",
  },
  hero: {
    eyebrow: "Cocina Colombo-Asiática · Salento, Quindío",
    title: "Ramen y cocina de autor en Salento",
    paragraph:
      "Sabores de Asia preparados con producto del Eje Cafetero, en un espacio íntimo rodeado de bosque.",
    ctaWhatsapp: "Escríbenos por WhatsApp",
    ctaDirections: "Cómo llegar",
    bottomLine: "Lunes a sábado desde la 1:00 p.m. · Carrera 5 #7-34",
    imageAlt: "Bowl de ramen humeante en MÂJI by Cerón, restaurante en Salento, Quindío",
  },
  about: {
    title: "Una cocina que une dos territorios",
    text: "MÂJI by Cerón nació en Salento en 2023, de la mano de la chef Diana Cerón y el Grupo Cerón. Nuestra carta se inspira en la cultura ramen y recorre sabores de Asia con técnicas e ingredientes del Quindío: pimientas de Popayán y Putumayo, ají Chiche Perro, cebolla junco de campesinos de la región y fermentados hechos en casa. Cada plato tiene un origen y una historia que nuestro equipo te puede contar en la mesa.",
  },
  signature: {
    title: "Recomendados del chef",
    subtitle: "Los platos fuertes que mejor cuentan quiénes somos.",
    note: "La carta completa incluye entradas, opciones vegetarianas, menú infantil, postres, bebidas fermentadas y cócteles de autor.",
    cta: "Ver la carta",
  },
  dishes: {
    macao: {
      tag: "El más pedido",
      name: "Macao Ramen",
      description:
        "Caldo de la casa aromatizado con siete pimientas, de Sichuan, Popayán y Putumayo. No pica: perfuma. Con panceta, tocineta crocante, camarón crocante y huevo.",
      alt: "Macao Ramen, ramen en Salento, en MÂJI by Cerón, restaurante en Salento",
    },
    junco: {
      tag: "Picante",
      name: "Junco Ramen",
      description:
        "Ramen con ají Chiche Perro de la región, pasta de miso, pollo apanado, jengibre, huevo y cebolla junco sembrada por campesinos locales.",
      alt: "Junco Ramen, ramen picante en MÂJI by Cerón, restaurante en Salento",
    },
    sirloin: {
      tag: "Ramen",
      name: "Sirloin Ramen",
      description:
        "Solomo a la parrilla, término medio, sobre caldo de miso, con omelette enrollado, ajonjolí, mantequilla y hongos.",
      alt: "Sirloin Ramen de MÂJI by Cerón, ramen en Salento",
    },
    fish: {
      tag: "Del mar",
      name: "Fish and Shrimp Ramen",
      description:
        "Camarón y pescado blanco en caldo de crema de pulpo con notas cítricas, jengibre, limonaria, achiote y aceite de coco.",
      alt: "Fish and Shrimp Ramen de MÂJI by Cerón, cocina asiática en Salento",
    },
    gyudon: {
      tag: "El arroz favorito",
      name: "Gyudon Rice",
      description:
        "Láminas de solomo a la parrilla caramelizadas con cebolla y hongos, sobre arroz kombu con maní, ajonjolí, rábano encurtido, tocineta crocante y especias.",
      alt: "Gyudon Rice de MÂJI by Cerón, dónde comer en Salento",
    },
    curry: {
      tag: "Arroz",
      name: "Curry Coconut Shrimp Rice",
      description:
        "Arroz perfumado con aceite de coco y curry, frutos secos y camarones, acompañado de encurtidos fermentados.",
      alt: "Curry Coconut Shrimp Rice de MÂJI by Cerón, cocina asiática en Salento",
    },
    shoku: {
      tag: "Parrilla",
      name: "Shoku Beef",
      description:
        "New York de 400 g a la parrilla sobre caldo de soya con mantequilla, miel y ají local. Con kimchi de la casa, habichuelas al limón, hongos y arroz blanco.",
      alt: "Shoku Beef de MÂJI by Cerón, restaurante en Salento, Quindío",
    },
    mushrooms: {
      tag: "Vegetariano",
      name: "Mushrooms Udon",
      description:
        "Udon seco con crema de leche y notas ahumadas, tres tipos de hongos confitados en tamarindo y miel, y monedas de zucchini apanado.",
      alt: "Mushrooms Udon vegetariano de MÂJI by Cerón, ramen y cocina asiática en Salento",
    },
  },
  beforeVisit: {
    title: "Antes de venir",
    items: {
      vegetarian: "Opciones vegetarianas y menú infantil",
      pet: "Pet friendly, con menú canino",
      languages: "Atención en español e inglés",
      intimate: "Espacio íntimo: escríbenos antes para asegurar tu mesa",
      pickup: "Puedes pedir para recoger. No hacemos domicilios",
      allergies: "Cuéntanos tus alergias o restricciones antes de ordenar",
    },
  },
  schedule: {
    title: "Horario",
    weekdays: "Lunes a jueves",
    weekdaysHours: "1:00 p.m. – 4:00 p.m. y 6:00 p.m. – 9:00 p.m.",
    weekend: "Viernes y sábado",
    weekendHours: "1:00 p.m. – 4:00 p.m. y 6:00 p.m. – 10:00 p.m.",
    sunday: "Domingo",
    sundayHours: "cerrado",
    note: "Cerramos todos los días entre 4:00 p.m. y 6:00 p.m. Las aperturas especiales de domingos y festivos se anuncian en nuestras redes. Si tienes dudas, escríbenos.",
  },
  location: {
    title: "Cómo llegar",
    address: "Carrera 5 #7-34, Mall La Herrería, Salento, Quindío, Colombia",
    subtitle:
      "A pocos minutos del Valle de Cocora, una parada ideal si buscas dónde comer en Salento.",
    notice:
      "El último tramo es peatonal. Google Maps suele marcar el punto una cuadra antes: sigue caminando por la Carrera 5 y busca nuestro aviso luminoso en el Mall La Herrería.",
    mapTitle: "Mapa de ubicación de MÂJI by Cerón en Salento, Quindío",
    ctaMaps: "Abrir en Google Maps",
    ctaWhatsapp: "Pedir indicaciones por WhatsApp",
  },
  closing: {
    title: "Te esperamos en Salento",
    text: "Escríbenos y te ayudamos a planear tu visita.",
    cta: "Escríbenos por WhatsApp",
  },
  footer: {
    schedule: "Lunes a sábado · 1:00 p.m. – 4:00 p.m. y 6:00 p.m. – 9:00 / 10:00 p.m.",
    sunday: "Domingo: cerrado",
    legal:
      "Consulta con nuestro equipo la información sobre ingredientes y alérgenos. El exceso de alcohol es perjudicial para la salud. Prohíbese el expendio de bebidas embriagantes a menores de edad.",
    copyright: "© MÂJI by Cerón · Salento, Quindío, Colombia.",
  },
  float: {
    label: "Escríbenos",
    aria: "Escribir a MÂJI by Cerón por WhatsApp",
  },
};